import { render } from "./TeikiResult.vue?vue&type=template&id=a20b9436&scoped=true"
import script from "./TeikiResult.vue?vue&type=script&lang=js"
export * from "./TeikiResult.vue?vue&type=script&lang=js"

import "./TeikiResult.vue?vue&type=style&index=0&id=a20b9436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20b9436"]])

export default __exports__